import PoolIcon from '@mui/icons-material/Pool';

export const Swim = () => <PoolIcon fontSize="small" />;
